import { useState, useEffect } from 'react';
import axios from 'axios';
import './ProductsView.css';

export default function ProductsView() {
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showDetailPopup, setShowDetailPopup] = useState(false);
  const [showEditPopup, setShowEditPopup] = useState(false);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    const res = await axios.get('https://spinelleapi.emedha.in/admin/product/api/products');
    setProducts(res.data.products);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this product?')) {
      await axios.delete(`https://spinelleapi.emedha.in/admin/product/api/products/${id}`);
      fetchProducts();
    }
  };

  const handleEdit = (product) => {
    setSelectedProduct(product);
    setShowEditPopup(true);
  };

  const handleDetailPopup = (product) => {
    setSelectedProduct(product);
    setShowDetailPopup(true);
  };

  const closePopups = () => {
    setShowDetailPopup(false);
    setShowEditPopup(false);
    setSelectedProduct(null);
  };

  return (
    <div className="products-view-container">
      <h2>Products List</h2>
      <table className="products-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Price</th>
            <th>Quantity</th>
            <th>Images</th>
            <th>Details</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {products.map((product) => (
            <tr key={product.id}>
              <td>{product.id}</td>
              <td>{product.name}</td>
              <td>{product.price}</td>
              <td>{product.quantity}</td>
              <td className="thumbnail-group">
                {product.images.slice(0, 3).map((img, index) => (
                  <img key={index} src={img.image_path} alt={product.name} className="thumbnail" />
                ))}
              </td>
              <td>
                <span className="view-more" onClick={() => handleDetailPopup(product)}>View More</span>
              </td>
              <td className="actions">
                <button onClick={() => handleEdit(product)}>Edit</button>
                <button onClick={() => handleDelete(product.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {showDetailPopup && selectedProduct && (
        <div className="modal-overlay">
          <div className="modal-content">
            <span className="modal-close" onClick={closePopups}>×</span>
            <h3>Product Details - {selectedProduct.name}</h3>
            <p><strong>Description:</strong> {selectedProduct.description}</p>
            <p><strong>Diamond Quality:</strong> {selectedProduct.diamond_quality}</p>
            <p><strong>Diamond Weight:</strong> {selectedProduct.diamond_weight}</p>
            <p><strong>Gold Weight:</strong> {selectedProduct.gold_weight}</p>
           <p><strong>Metal Quality:</strong> {(selectedProduct.metal_quality || []).join(', ')}</p>
<p><strong>Metal Colors:</strong> {(selectedProduct.metal_colors || []).join(', ')}</p>
<p><strong>Collections:</strong> {(selectedProduct.collections || []).join(', ')}</p>

            <div className="modal-images">
              {selectedProduct.images.map((img, index) => (
                <img key={index} src={img.image_path} alt={selectedProduct.name} />
              ))}
            </div>
          </div>
        </div>
      )}

      {showEditPopup && selectedProduct && (
        <EditProductForm product={selectedProduct} onClose={closePopups} onRefresh={fetchProducts} />
      )}
    </div>
  );
}

function EditProductForm({ product, onClose, onRefresh }) {
const [form, setForm] = useState({
   ...product,
   metal_quality: product.metal_quality || [],
   metal_colors: product.metal_colors || [],
   collections: product.collections || [],
   price_18kt: product.price_18kt || '', 
   price_14kt: product.price_14kt || '', 
   category: product.category || '',  // New field for category
   product_type: product.product_type || '' // New field for product_type
});

console.log('form',form)


  const [colorImageMap, setColorImageMap] = useState({});
  const [additionalImages, setAdditionalImages] = useState([]);
  const [previewImages, setPreviewImages] = useState(product.images || []);

  const [categories, setCategories] = useState([]);
  const [productTypes, setProductTypes] = useState([]);
  
  useEffect(() => {
    // Fetch categories when the component mounts
    fetchCategories();
  }, []);

  useEffect(() => {
    // Fetch product types based on the selected category
    if (form.category) {
      fetchProductTypes(form.category);
    }
  }, [form.category]);

  const fetchCategories = async () => {
    try {
      const res = await axios.get('https://spinelleapi.emedha.in/admin/product/api/categories');
      setCategories(res.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const fetchProductTypes = async (category) => {
    try {
      const res = await axios.get(`https://spinelleapi.emedha.in/admin/product/api/product_types/${category}`);
      setProductTypes(res.data);
    } catch (error) {
      console.error("Error fetching product types:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleMultiSelect = (e, field) => {
    const { value, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [field]: checked
        ? [...prev[field], value]
        : prev[field].filter((v) => v !== value),
    }));
  };

  const handleImageUpload = (e, color) => {
    const files = Array.from(e.target.files);
    setColorImageMap((prev) => ({ ...prev, [color]: files }));

    const filePreviews = files.map((file) => ({
      color: color,
      image_path: URL.createObjectURL(file),
      newUpload: true,
    }));

    setPreviewImages((prev) => [
      ...prev.filter((img) => img.color !== color),
      ...filePreviews,
    ]);
  };

  const handleAdditionalImageUpload = (e) => {
    const files = Array.from(e.target.files);
    setAdditionalImages((prev) => [...prev, ...files]);

    const filePreviews = files.map((file) => ({
      color: null,
      image_path: URL.createObjectURL(file),
      newUpload: true,
    }));

    setPreviewImages((prev) => [...prev, ...filePreviews]);
  };

const submitEdit = async () => {
  const formData = new FormData();

  // Append changed fields
  Object.keys(form).forEach((key) => {
    if (JSON.stringify(form[key]) !== JSON.stringify(product[key])) {
      if (Array.isArray(form[key])) {
        form[key].forEach((v) => formData.append(`${key}[]`, v));
      } else {
        formData.append(key, form[key]);
      }
    }
  });

  // Append Images to Delete (send image IDs)
  imagesToDelete.forEach((id) => {
    formData.append('images_to_delete', id);
  });

  // Append new color-wise images
  Object.entries(colorImageMap).forEach(([color, files]) => {
    files.forEach((file) => {
      formData.append(`color_images[${color}][]`, file);
    });
  });

  // Append additional images
  additionalImages.forEach((file) => {
    formData.append('additional_images[]', file);
  });

  try {
    await axios.put(
      `https://spinelleapi.emedha.in/admin/product/api/products/${form.id}`,
      formData
    );
    onRefresh();
    onClose();
  } catch (error) {
    console.error('Error updating product:', error);
  }
};



// Fetch categories and product types after product data is loaded
useEffect(() => {
    if (product.length > 0) {
        // Assuming products are fetched and available
        const firstProduct = product[0];
        setForm({
          ...firstProduct,
          metal_quality: firstProduct.metal_quality || [],
          metal_colors: firstProduct.metal_colors || [],
          collections: firstProduct.collections || [],
          price_18kt: firstProduct.price_18kt || '', 
          price_14kt: firstProduct.price_14kt || '', 
          category: firstProduct.category || '',  // Initialize category
          product_type: firstProduct.product_type || '',  // Initialize product type
        });
    }
}, [product]);

useEffect(() => {
    if (form.category) {
        fetchProductTypes(form.category);  // Fetch product types after category is selected
    }
}, [form.category]);




  const [imagesToDelete, setImagesToDelete] = useState([]);

const handleRemoveImage = (img) => {
  // If image has an ID from DB, mark for deletion
  if (img.id) {
    setImagesToDelete((prev) => [...prev, img.id]);
  }

  // Remove from previewImages
  setPreviewImages((prev) => prev.filter((i) => i !== img));

  // Also clean from colorImageMap if it's a newly uploaded image
  if (img.newUpload && img.color) {
    setColorImageMap((prev) => ({
      ...prev,
      [img.color]: prev[img.color].filter((file) => file.name !== img.image_path),
    }));
  }
};


  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <span className="modal-close" onClick={onClose}>
          ×
        </span>
        <h3 className="form-title">Edit Product - {form.name}</h3>

        <div className="form-grid">
          <div className="form-group">
            <label>Product Name</label>
            <input
              name="name"
              value={form.name}
              onChange={handleInputChange}
            />
          </div>

          <div className="form-group">
            <label>Description</label>
            <textarea
              name="description"
              value={form.description}
              onChange={handleInputChange}
            ></textarea>
          </div>

          <div className="form-row">
              <div className="form-row">
            <div className="form-group">
              <label>Price for 18kt</label>
              <input
                name="price_18kt"
                value={form.price_18kt}
                onChange={handleInputChange}
                type="number"
                step="0.01"
              />
            </div>
            <div className="form-group">
              <label>Price for 14kt</label>
              <input
                name="price_14kt"
                value={form.price_14kt}
                onChange={handleInputChange}
                type="number"
                step="0.01"
              />
            </div>
          </div>

          <div className="form-row">
   <div className="form-group">
  <label>Category</label>
<select
  name="category"
  value={form.category}
  onChange={(e) => handleInputChange(e)} // Calls the handler on change
>
  <option value="">Select Category</option>
  {categories.map((category) => (
    <option key={category.id} value={category.name}>
      {category.name}
    </option>
  ))}
</select>

</div>


<div className="form-group">
  <label>Product Type</label>
  <select
    name="product_type"
    value={form.product_type}
    onChange={(e) => handleInputChange(e)} // Calls the handler on change
    disabled={!form.category} // Disable product type if no category is selected
  >
    <option value="">Select Product Type</option>
    {productTypes.map((type) => (
      <option key={type.id} value={type.name}> {/* Use type.id */}
        {type.name}
      </option>
    ))}
  </select>
</div>

          </div>
            <div className="form-group">
              <label>Quantity</label>
              <input
                name="quantity"
                value={form.quantity}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Diamond Quality</label>
              {['EF/VVS', 'GH/VS'].map((dq) => (
                <label key={dq} className="inline-checkbox">
                  <input
                    type="radio"
                    name="diamond_quality"
                    checked={form.diamond_quality === dq}
                    value={dq}
                    onChange={handleInputChange}
                  />{' '}
                  {dq}
                </label>
              ))}
            </div>

            <div className="form-group">
              <label>Diamond Weight</label>
              <input
                name="diamond_weight"
                value={form.diamond_weight}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-group">
              <label>Gold Weight</label>
              <input
                name="gold_weight"
                value={form.gold_weight}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="form-group">
            <label>Metal Quality</label>
            {['18kt', '14kt'].map((q) => (
              <label key={q} className="inline-checkbox">
                <input
                  type="checkbox"
                  checked={form.metal_quality.includes(q)}
                  value={q}
                  onChange={(e) => handleMultiSelect(e, 'metal_quality')}
                />{' '}
                {q}
              </label>
            ))}
          </div>

          <div className="form-group">
            <label>Metal Colors</label>
            {['Rose Gold', 'Yellow Gold', 'White Gold'].map((color) => (
              <label key={color} className="inline-checkbox">
                <input
                  type="checkbox"
                  checked={form.metal_colors.includes(color)}
                  value={color}
                  onChange={(e) => handleMultiSelect(e, 'metal_colors')}
                />{' '}
                {color}
              </label>
            ))}
          </div>

          {/* Color-wise Upload Section */}
          <div className="form-group">
            <label>Upload Color-wise Images</label>
            {['Rose Gold', 'Yellow Gold', 'White Gold'].map((color) => (
              <div key={color} className="upload-section">
                <span>{color}</span>
                <input
                  type="file"
                  multiple
                  onChange={(e) => handleImageUpload(e, color)}
                />
              </div>
            ))}
          </div>

          {/* Additional Images Upload */}
          <div className="form-group">
            <label>Upload Additional Images</label>
            <input
              type="file"
              multiple
              onChange={handleAdditionalImageUpload}
            />
          </div>

          {/* --- Image Previews --- */}
  <div className="form-group">
  <label>Current Images</label>
  <div className="preview-gallery">
    {previewImages.map((img, index) => (
      <div key={index} className="image-wrapper">
        <img src={img.image_path} alt="preview" className="preview-thumb" />
        <span
          className="remove-icon"
          onClick={() => handleRemoveImage(img)}
        >
          ×
        </span>
      </div>
    ))}
  </div>
</div>


          <div className="form-actions">
            <button className="btn-primary" onClick={submitEdit}>
              Update Product
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}



